import React, { useState, useEffect } from 'react';

const API = 'https://api.pixventa.com';

const PAGINAS = [
  { id:'dashboard', nombre:'Dashboard',    desc:'Ver métricas y resumen general' },
  { id:'negocios',  nombre:'Negocios',     desc:'Gestión de clientes y suscripciones' },
  { id:'planes',    nombre:'Planes',       desc:'Crear y editar planes del sistema' },
  { id:'alertas',   nombre:'Alertas',      desc:'Ver y gestionar alertas de pagos' },
  { id:'reportes',  nombre:'Reportes',     desc:'Ver reportes de productos e ingresos' },
  { id:'usuarios',  nombre:'Usuarios',     desc:'Gestión de usuarios del sistema' },
  { id:'config',    nombre:'Configuración',desc:'Configuración general del sistema' },
];

const ROLES = ['Admin','Soporte','Ventas','Operaciones'];

const ROL_BADGE = {
  Admin:       { bg:'#EEEDFE', color:'#26215C' },
  Soporte:     { bg:'#E6F1FB', color:'#042C53' },
  Ventas:      { bg:'#E1F5EE', color:'#085041' },
  Operaciones: { bg:'#FFF3E0', color:'#E65100' },
};

function iniciales(nombre) {
  return (nombre||'').split(' ').slice(0,2).map(x=>x[0]).join('').toUpperCase();
}

function permisosVacios() {
  const p = {};
  PAGINAS.forEach(pg => { p[pg.id] = { ver:false, editar:false, acciones:false }; });
  return p;
}

function formatAcceso(str) {
  if (!str) return 'Nunca';
  return new Date(str).toLocaleString('es-MX', { dateStyle:'short', timeStyle:'short' });
}

const S = {
  topbar:    { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 },
  h1:        { fontSize:20, fontWeight:700, color:'#0D1F1A' },
  btnNew:    { padding:'8px 16px', borderRadius:10, border:'none', background:'#075E54', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  card:      { background:'white', borderRadius:12, border:'1px solid #E4EDE8', overflow:'hidden', marginBottom:16 },
  table:     { width:'100%', borderCollapse:'collapse', fontSize:12 },
  th:        { padding:'9px 12px', textAlign:'left', fontSize:11, fontWeight:700, color:'#7A8F89', borderBottom:'1px solid #E4EDE8', background:'#F0F4F0' },
  td:        { padding:'10px 12px', borderBottom:'1px solid #E4EDE8', color:'#0D1F1A', verticalAlign:'middle' },
  badge:     { display:'inline-block', padding:'2px 8px', borderRadius:20, fontSize:11, fontWeight:600 },
  avatar:    { width:32, height:32, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:700, flexShrink:0 },
  userInfo:  { display:'flex', alignItems:'center', gap:8 },
  userName:  { fontSize:13, fontWeight:700, color:'#0D1F1A' },
  userEmail: { fontSize:11, color:'#7A8F89' },
  btn:       { fontSize:11, padding:'4px 8px', borderRadius:8, border:'1px solid #E4EDE8', background:'none', color:'#7A8F89', cursor:'pointer', fontFamily:'inherit', marginRight:4 },
  btnOk:     { color:'#085041', borderColor:'#5DCAA5' },
  btnRojo:   { color:'#A32D2D', borderColor:'#F09595' },
  btnVer:    { color:'#042C53', borderColor:'#90caf9' },
  overlay:   { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center', padding:16 },
  modal:     { background:'white', borderRadius:16, width:540, maxHeight:'92vh', overflowY:'auto' },
  mHdr:      { padding:'14px 16px', borderBottom:'1px solid #E4EDE8', display:'flex', justifyContent:'space-between', alignItems:'center' },
  mTitle:    { fontSize:15, fontWeight:800, color:'#0D1F1A' },
  mClose:    { width:28, height:28, borderRadius:'50%', background:'#F0F4F0', border:'none', cursor:'pointer', fontSize:14, color:'#7A8F89' },
  tabs:      { display:'flex', borderBottom:'1px solid #E4EDE8' },
  tab:       { flex:1, padding:'10px', textAlign:'center', fontSize:12, color:'#7A8F89', cursor:'pointer', border:'none', background:'none', fontFamily:'inherit', borderBottom:'2px solid transparent' },
  tabActive: { color:'#075E54', fontWeight:700, borderBottom:'2px solid #075E54' },
  tabBody:   { padding:16 },
  field:     { marginBottom:14 },
  label:     { display:'block', fontSize:11, fontWeight:700, color:'#7A8F89', textTransform:'uppercase', letterSpacing:0.5, marginBottom:5 },
  input:     { width:'100%', background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:10, padding:'9px 12px', fontSize:13, color:'#0D1F1A', outline:'none', fontFamily:'inherit', boxSizing:'border-box' },
  select:    { width:'100%', background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:10, padding:'9px 12px', fontSize:13, color:'#0D1F1A', outline:'none', fontFamily:'inherit', boxSizing:'border-box', cursor:'pointer' },
  grid2:     { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 },
  permHdr:   { display:'grid', gridTemplateColumns:'1fr 50px 50px 60px', fontSize:10, fontWeight:700, color:'#7A8F89', textTransform:'uppercase', letterSpacing:0.4, padding:'8px 12px', borderBottom:'1px solid #E4EDE8', background:'#F0F4F0' },
  permRow:   { display:'grid', gridTemplateColumns:'1fr 50px 50px 60px', alignItems:'center', padding:'10px 12px', borderBottom:'1px solid #E4EDE8' },
  checkWrap: { display:'flex', justifyContent:'center' },
  check:     { width:18, height:18, borderRadius:4, border:'1.5px solid #E4EDE8', background:'#F0F4F0', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' },
  checkOn:   { background:'#075E54', borderColor:'#075E54' },
  mFooter:   { padding:'12px 16px', borderTop:'1px solid #E4EDE8', display:'flex', justifyContent:'flex-end', gap:8 },
  fBtnCancel:{ padding:'9px 16px', borderRadius:10, border:'1px solid #E4EDE8', background:'#F0F4F0', color:'#7A8F89', fontSize:13, cursor:'pointer', fontFamily:'inherit' },
  fBtnSave:  { padding:'9px 16px', borderRadius:10, border:'none', background:'#075E54', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  success:   { background:'#E1F5EE', border:'1px solid #5DCAA5', borderRadius:10, padding:'10px 14px', fontSize:12, color:'#085041', margin:'0 16px 12px' },
  errorBox:  { background:'#FCEBEB', border:'1px solid #F09595', borderRadius:10, padding:'10px 14px', fontSize:12, color:'#A32D2D', margin:'0 16px 12px' },
  cargando:  { textAlign:'center', padding:40, color:'#7A8F89', fontSize:13 },
};

export default function Usuarios() {
  const [usuarios,   setUsuarios]   = useState([]);
  const [cargando,   setCargando]   = useState(true);
  const [modal,      setModal]      = useState(null);
  const [tabActiva,  setTabActiva]  = useState('datos');
  const [form,       setForm]       = useState({});
  const [permisos,   setPermisos]   = useState({});
  const [hayCambios, setHayCambios] = useState(false);
  const [msgOk,      setMsgOk]      = useState('');
  const [msgError,   setMsgError]   = useState('');
  const [guardando,  setGuardando]  = useState(false);

  useEffect(() => { cargarUsuarios(); }, []);

  async function cargarUsuarios() {
    try {
      setCargando(true);
      const res = await fetch(`${API}/admin/usuarios`);
      const data = await res.json();
      setUsuarios(data.map(u => ({
        ...u,
        permisos: typeof u.permisos === 'string' ? JSON.parse(u.permisos) : (u.permisos || permisosVacios()),
      })));
    } catch (err) {
      console.error('Error cargando usuarios:', err);
    } finally {
      setCargando(false);
    }
  }

  function abrirNuevo() {
    setForm({ nombre:'', email:'', rol:'Soporte', pass:'', passConfirm:'' });
    setPermisos(permisosVacios());
    setHayCambios(false); setTabActiva('datos'); setMsgOk(''); setMsgError('');
    setModal('nuevo');
  }

  function abrirEditar(u) {
    setForm({ nombre:u.nombre, email:u.email, rol:u.rol, pass:'', passConfirm:'' });
    const p = typeof u.permisos === 'string' ? JSON.parse(u.permisos) : (u.permisos || permisosVacios());
    // Asegura que todas las páginas tienen los 3 permisos
    const pCompleto = {};
    PAGINAS.forEach(pg => { pCompleto[pg.id] = { ver:false, editar:false, acciones:false, ...(p[pg.id]||{}) }; });
    setPermisos(pCompleto);
    setHayCambios(false); setTabActiva('datos'); setMsgOk(''); setMsgError('');
    setModal(u);
  }

  function cerrar() {
    if (hayCambios && !window.confirm('¿Cerrar sin guardar cambios?')) return;
    setModal(null); setHayCambios(false); setMsgOk(''); setMsgError('');
  }

  function actualizarForm(campo, valor) {
    setForm(prev => ({ ...prev, [campo]: valor }));
    setHayCambios(true);
  }

  function togglePermiso(pagina, tipo) {
    setPermisos(prev => ({ ...prev, [pagina]: { ...prev[pagina], [tipo]: !prev[pagina][tipo] } }));
    setHayCambios(true);
  }

  async function guardar() {
    setMsgError('');
    if (!form.nombre.trim()) { setMsgError('Escribe el nombre'); return; }
    if (!form.email.trim())  { setMsgError('Escribe el email'); return; }
    if (modal === 'nuevo' && !form.pass) { setMsgError('Escribe una contraseña'); return; }
    if (form.pass && form.pass !== form.passConfirm) { setMsgError('Las contraseñas no coinciden'); return; }
    if (form.pass && form.pass.length < 8) { setMsgError('La contraseña debe tener al menos 8 caracteres'); return; }

    setGuardando(true);
    try {
      const payload = { nombre: form.nombre, email: form.email, rol: form.rol, permisos, estado: 'activo' };
      if (form.pass) payload.password = form.pass;

      if (modal === 'nuevo') {
        const res = await fetch(`${API}/admin/usuarios`, {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify(payload),
        });
        const nuevo = await res.json();
        if (nuevo.error) { setMsgError(nuevo.error); return; }
        setUsuarios(prev => [...prev, { ...nuevo, permisos }]);
      } else {
        const res = await fetch(`${API}/admin/usuarios/${modal.id}`, {
          method:'PUT', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ ...payload, estado: modal.estado }),
        });
        const data = await res.json();
        if (data.error) { setMsgError(data.error); return; }
        setUsuarios(prev => prev.map(u => u.id === modal.id ? { ...u, ...payload } : u));
      }
      setMsgOk(modal === 'nuevo' ? '✅ Usuario creado correctamente' : '✅ Usuario actualizado correctamente');
      setHayCambios(false);
      setTimeout(() => { setModal(null); setMsgOk(''); }, 1200);
    } catch (err) {
      setMsgError('Error: ' + err.message);
    } finally {
      setGuardando(false);
    }
  }

  async function toggleEstado(u) {
    const accion = u.estado === 'activo' ? 'desactivar' : 'activar';
    if (!window.confirm(`¿Seguro que quieres ${accion} a ${u.nombre}?`)) return;
    const nuevoEstado = u.estado === 'activo' ? 'inactivo' : 'activo';
    try {
      await fetch(`${API}/admin/usuarios/${u.id}`, {
        method:'PUT', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ ...u, estado: nuevoEstado }),
      });
      setUsuarios(prev => prev.map(x => x.id === u.id ? { ...x, estado: nuevoEstado } : x));
    } catch (err) { alert('Error: ' + err.message); }
  }

  if (cargando) return <div style={S.cargando}>Cargando usuarios...</div>;

  return (
    <div>
      <div style={S.topbar}>
        <h1 style={S.h1}>Usuarios ({usuarios.length})</h1>
        <button style={S.btnNew} onClick={abrirNuevo}>＋ Nuevo usuario</button>
      </div>

      <div style={S.card}>
        <table style={S.table}>
          <thead>
            <tr>
              <th style={S.th}>Usuario</th>
              <th style={S.th}>Rol</th>
              <th style={S.th}>Último acceso</th>
              <th style={S.th}>Estado</th>
              <th style={S.th}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {usuarios.length === 0 && (
              <tr><td colSpan={5} style={{...S.td, textAlign:'center', color:'#7A8F89', padding:32}}>Sin usuarios registrados</td></tr>
            )}
            {usuarios.map(u => {
              const rolStyle = ROL_BADGE[u.rol] || ROL_BADGE.Soporte;
              return (
                <tr key={u.id}>
                  <td style={S.td}>
                    <div style={S.userInfo}>
                      <div style={{ ...S.avatar, background: rolStyle.bg, color: rolStyle.color }}>{iniciales(u.nombre)}</div>
                      <div><div style={S.userName}>{u.nombre}</div><div style={S.userEmail}>{u.email}</div></div>
                    </div>
                  </td>
                  <td style={S.td}><span style={{ ...S.badge, background: rolStyle.bg, color: rolStyle.color }}>{u.rol}</span></td>
                  <td style={{ ...S.td, fontSize:11, color:'#7A8F89' }}>{formatAcceso(u.ultimo_acceso)}</td>
                  <td style={S.td}>
                    <span style={{ ...S.badge, background: u.estado==='activo'?'#E1F5EE':'#F0F4F0', color: u.estado==='activo'?'#085041':'#7A8F89' }}>
                      {u.estado === 'activo' ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td style={S.td}>
                    <button style={{ ...S.btn, ...S.btnVer }} onClick={() => abrirEditar(u)}>✏️ Editar</button>
                    {u.estado === 'activo'
                      ? <button style={{ ...S.btn, ...S.btnRojo }} onClick={() => toggleEstado(u)}>Desactivar</button>
                      : <button style={{ ...S.btn, ...S.btnOk  }} onClick={() => toggleEstado(u)}>Activar</button>
                    }
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={S.overlay} onClick={e => e.target===e.currentTarget && cerrar()}>
          <div style={S.modal}>
            <div style={S.mHdr}>
              <div style={S.mTitle}>{modal==='nuevo' ? '＋ Nuevo usuario' : `✏️ ${modal.nombre}`}</div>
              <button style={S.mClose} onClick={cerrar}>✕</button>
            </div>

            {msgOk    && <div style={S.success}>{msgOk}</div>}
            {msgError && <div style={S.errorBox}>⚠️ {msgError}</div>}

            <div style={S.tabs}>
              <button style={{ ...S.tab, ...(tabActiva==='datos'?S.tabActive:{}) }} onClick={() => setTabActiva('datos')}>Datos</button>
              <button style={{ ...S.tab, ...(tabActiva==='permisos'?S.tabActive:{}) }} onClick={() => setTabActiva('permisos')}>Permisos</button>
            </div>

            {tabActiva === 'datos' && (
              <div style={S.tabBody}>
                <div style={S.grid2}>
                  <div style={S.field}>
                    <label style={S.label}>Nombre</label>
                    <input style={S.input} value={form.nombre||''} onChange={e => actualizarForm('nombre', e.target.value)} />
                  </div>
                  <div style={S.field}>
                    <label style={S.label}>Rol</label>
                    <select style={S.select} value={form.rol||'Soporte'} onChange={e => actualizarForm('rol', e.target.value)}>
                      {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
                    </select>
                  </div>
                </div>
                <div style={S.field}>
                  <label style={S.label}>Email</label>
                  <input style={S.input} value={form.email||''} onChange={e => actualizarForm('email', e.target.value)} />
                </div>
                <div style={S.grid2}>
                  <div style={S.field}>
                    <label style={S.label}>{modal==='nuevo' ? 'Contraseña' : 'Nueva contraseña'}</label>
                    <input style={S.input} type="password" placeholder={modal==='nuevo' ? 'Mínimo 8 caracteres' : 'Dejar vacío para no cambiar'} value={form.pass||''} onChange={e => actualizarForm('pass', e.target.value)} />
                  </div>
                  <div style={S.field}>
                    <label style={S.label}>Confirmar contraseña</label>
                    <input style={S.input} type="password" placeholder="Repetir contraseña" value={form.passConfirm||''} onChange={e => actualizarForm('passConfirm', e.target.value)} />
                  </div>
                </div>
              </div>
            )}

            {tabActiva === 'permisos' && (
              <div>
                <div style={S.permHdr}>
                  <div>Página</div>
                  <div style={{ textAlign:'center' }}>Ver</div>
                  <div style={{ textAlign:'center' }}>Editar</div>
                  <div style={{ textAlign:'center' }}>Acciones</div>
                </div>
                {PAGINAS.map(pg => (
                  <div key={pg.id} style={{ ...S.permRow, background: permisos[pg.id]?.ver ? 'white' : '#fafafa' }}>
                    <div>
                      <div style={{ fontSize:13, color:'#0D1F1A' }}>{pg.nombre}</div>
                      <div style={{ fontSize:11, color:'#7A8F89' }}>{pg.desc}</div>
                    </div>
                    {['ver','editar','acciones'].map(tipo => (
                      <div key={tipo} style={S.checkWrap}>
                        <div style={{ ...S.check, ...(permisos[pg.id]?.[tipo] ? S.checkOn : {}) }}
                          onClick={() => togglePermiso(pg.id, tipo)}>
                          {permisos[pg.id]?.[tipo] && <span style={{ color:'white', fontSize:11 }}>✓</span>}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}

            <div style={S.mFooter}>
              <button style={S.fBtnCancel} onClick={cerrar}>Cancelar</button>
              <button style={{ ...S.fBtnSave, opacity: guardando?0.7:1 }} onClick={guardar} disabled={guardando}>
                {guardando ? 'Guardando...' : '✓ Guardar cambios'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}